import api from "../config/api";


export const getBillProcessByDate = async (date) => {
  try {
    const res = await api.get(`/bill/process/?date=${date}`);
    return res.data;
  } catch (err) {
    throw err.response?.data || err;
  }
};

export const saveBillProcessBulk = async (payload) => {
  try {
    const res = await api.post(`/bill/process/`, payload);
    return res.data;
  } catch (err) {
    throw err.response?.data || err;
  }
};

